import React from "react";
import Image from "next/legacy/image";

const ImageUI = (props) => {
  const {
    className,
    layout = "fill",
    children,
    src,
    alt,
    title,
    priority,
    unoptimized,
    width,
    height,
    ...rest
  } = props;

  return (
    <Image
      layout={!width && !height ? layout : "intrinsic"}
      width={width}
      height={height}
      className={className}
      src={src}
      alt={alt || "alt"}
      title={title || ""}
      priority={priority || true}
      unoptimized={unoptimized || true}
      {...rest}
    >
      {children}
    </Image>
  );
};

export default ImageUI;
